var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcCarouselRightNavigation(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 58,
    viewBox: "0 0 58 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_20132_7067",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 8,
    y: 8,
    width: 42,
    height: 42
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 8,
    width: 42,
    height: 42,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_20132_7067)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.8359 41.1619L39.1521 29.8666C39.2794 29.7393 39.3692 29.6051 39.4215 29.4638C39.4738 29.3226 39.5 29.17 39.5 29.006C39.5 28.8421 39.4738 28.6895 39.4215 28.5483C39.3692 28.407 39.2794 28.2727 39.1521 28.1454L27.8229 16.8162C27.5665 16.5598 27.2526 16.4316 26.8812 16.4316C26.5097 16.4316 26.1845 16.5712 25.9055 16.8502C25.6351 17.1205 25.5 17.4387 25.5 17.8049C25.5 18.1712 25.6351 18.4894 25.9055 18.7597L36.1518 29.006L25.8924 39.2654C25.636 39.5218 25.5079 39.8322 25.5079 40.1967C25.5079 40.5611 25.6474 40.8829 25.9264 41.1619C26.1967 41.4322 26.5149 41.5673 26.8812 41.5673C27.2474 41.5673 27.5656 41.4322 27.8359 41.1619Z",
    fill: "#141414"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcCarouselRightNavigation);
export default __webpack_public_path__ + "static/media/ic-carousel-right-navigation.8f35364d338a3cbddbc2c38a526434ac.svg";
export { ForwardRef as ReactComponent };